module.exports = __webpack_public_path__ + "static/media/arrowContractedIcon.217a8822.svg";